import { FacturationActif } from "./FacturationActif"
import BackOfficeAPIClient from "../../../clients/BackofficeAPIClient"
import React, { useEffect, useState } from "react"

export default function Facturation() {
    const backofficeApiClient = new BackOfficeAPIClient()

    const [ isLoading, setIsLoading ] = useState<boolean>(true)
    const [ datas, setDatas ] = useState<FacturationActif>(new FacturationActif())
    const [ error, setError ] = useState<string>("")

    useEffect(() => {
        fetchDatas()
    }, [])

    const fetchDatas = async () => {
        try {
            setIsLoading(true)
            const resultConfig = await backofficeApiClient.get<FacturationActif>("/interfaces/facturation/dashboard")
            setDatas(resultConfig)

        } catch (err: any) {
            const message: string = JSON.parse(err.message).message ?? ""
            setError(message)
        } finally {
            setIsLoading(false)
        }
    }

    const updateEdataVoice = async () => {
        try {
            if (!window.confirm(`Êtes-vous sûr de vouloir ${datas.eDataVoiceActif ? "désactiver" : "activer"} eDataVoice ?`))
                return
            await backofficeApiClient.post("/interfaces/facturation/edatavoice", { actif: !datas.eDataVoiceActif })
            await fetchDatas()

        } catch (err: any) {
            const message: string = JSON.parse(err.message).message ?? ""
            setError(message)
        }
    }

    const updateEseller = async () => {
        try {
            if (!window.confirm(`Êtes-vous sûr de vouloir ${datas.eSellerActif ? "désactiver" : "activer"} eSeller ?`))
                return
            await backofficeApiClient.post("/interfaces/facturation/eseller", { actif: !datas.eSellerActif })
            await fetchDatas()
        } catch (err: any) {
            const message: string = JSON.parse(err.message).message ?? ""
            setError(message)
        }
    }

    return (
        <div className="row mx-4 gx-4">
            <div className={"col-3"}>
                <div className={`card ${isLoading ? "bg-light" : (datas.eSellerActif ? "bg-success text-white" : "bg-danger text-white")}`}>
                    <div className="card-header">eSeller</div>
                    {isLoading ?
                        <div className="card-body">
                            <h4 className="card-title">Chargement...</h4>
                            <p className="card-text text-center">
                                <i className="fa fa-spinner fa-spin fa-fw"></i>
                            </p>
                        </div>
                        : error !== "" ?
                            <div className="card-body">
                                <h4 className="card-title">Erreur</h4>
                                <p className="card-text">
                                    {error}
                                </p>
                            </div> :
                            <div className="card-body container-fluid">
                                <div className="row text-center mb-3">
                                    <div className="col-5">
                                        <img src="../logo.png" alt="logo" className="img-fluid"/>
                                    </div>
                                </div>
                                <button type="button" className="btn btn-primary m-2" onClick={updateEseller}>
                                    {datas.eSellerActif ? "Désactiver" : "Activer"}
                                </button>
                            </div>
                    }
                </div>
            </div>
            <div className={"col-3"}>
                <div className={`card ${isLoading ? "bg-light" : (datas.eDataVoiceActif ? "bg-success text-white" : "bg-danger text-white")}`}>
                    <div className="card-header">eData Voice</div>
                    {isLoading ?
                        <div className="card-body">
                            <h4 className="card-title">Chargement...</h4>
                            <p className="card-text text-center">
                                <i className="fa fa-spinner fa-spin fa-fw"></i>
                            </p>
                        </div>
                        : error !== "" ?
                            <div className="card-body">
                                <h4 className="card-title">Erreur</h4>
                                <p className="card-text">
                                    {error}
                                </p>
                            </div> :

                            <div className="card-body container-fluid">
                                <div className="row text-center mb-3">
                                    <div className="col-5">
                                        <img src="../Logo-eDataVoice.png" alt="logo" className="img-fluid"/>
                                    </div>
                                </div>
                                <button type="button" className="btn btn-primary m-2" onClick={updateEdataVoice}>
                                    {datas.eDataVoiceActif ? "Désactiver" : "Activer"}
                                </button>
                            </div>
                    }
                </div>
            </div>
        </div>
    )
}
